import { FeatureCollection } from 'geojson'
import { MS_UUID } from 'map-style-utils'
import { Source } from 'ms-map-gl'
import { FC } from 'react'
import {
  useMapToolbarStore,
  VISUALIZATION_TYPES
} from '~map-preview/states/mapToolbar'
import {
  MARKER_TYPES,
  useMarkerCategory,
  useMarkerType
} from '~map-preview/states/marker'
import { geojsonify } from '~map-preview/utils/geojsonify'
import { HeatmapLayer } from '../../Layers/HeatmapLayer'
import { CategoryLayer } from '../../Layers/MarkerLayer/Category'
import { PointLayer } from '../../Layers/MarkerLayer/Point'

const DEFAULT_SOURCE_ID = 'mapstack-points'
const DEFAULT_TYPE = 'geojson'

type GeojsonSourceProps = {
  geojson?: FeatureCollection
}

export const GeojsonSource: FC<GeojsonSourceProps> = geojsonify((props) => {
  const { geojson } = props

  const markerType = useMarkerType()
  const markerCategory = useMarkerCategory()
  const { visualization } = useMapToolbarStore()

  const key = Object.keys(visualization)[0]
  const visualizationType = key
    ? visualization[key].type
    : VISUALIZATION_TYPES['marker']

  return (
    <Source
      id={DEFAULT_SOURCE_ID}
      type={DEFAULT_TYPE}
      data={geojson}
      promoteId={MS_UUID}
    >
      {visualizationType === VISUALIZATION_TYPES['heatmap'] && <HeatmapLayer />}

      {/* {visualizationType === VISUALIZATION_TYPES['marker'] &&
        markerType === MARKER_TYPES.INDIVIDUAL && <PointLayer />} */}

      {visualizationType === VISUALIZATION_TYPES['category'] &&
        markerType === MARKER_TYPES.CATEGORIES &&
        markerCategory && <CategoryLayer geojson={geojson} />}
    </Source>
  )
})
